import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLandingPage from '../views/MainLandingPage.vue'
import OnBuild from '../views/OnBuild.vue'
import { AuthRoutes } from '@/modules/auth/router'
import { UserRoutes } from '@/modules/users/router'
import { DocumentsRoutes } from '@/modules/documents/router'
import { SignersRoutes } from '@/modules/signers/router'
import { CatalogsRoutes } from '@/modules/catalogs/router'
import { DashboardRoutes } from '@/modules/dashboard/router'

import store from '@/store'

Vue.use(VueRouter)

const routes = [
  ...AuthRoutes,
  ...UserRoutes,
  ...DocumentsRoutes,
  ...SignersRoutes,
  ...CatalogsRoutes,
  ...DashboardRoutes,
  {
    path: '/',
    name: 'Landing',
    component: MainLandingPage
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/avisoprivacidad',
    name: 'AvisoPrivacidad',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "avisoPrivacidad" */ '../views/AvisoPrivacidad.vue'
      )
  },
  {
    path: '/archivo',
    name: 'Archivo',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "archivo" */ '../views/Archivo.vue')
  },
  {
    path: '*',
    component: OnBuild,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['user/loggedIn']) {
      return next()
    }

    next('/')
  } else {
    next()
  }
})

export default router
